import { render, staticRenderFns } from "./PlannedLevelStatsIncreases.vue?vue&type=template&id=2a4a8c07&scoped=true&"
import script from "./PlannedLevelStatsIncreases.vue?vue&type=script&lang=js&"
export * from "./PlannedLevelStatsIncreases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a8c07",
  null
  
)

export default component.exports